<template>
    <div class="main-body">
        <div class="header">
            来访登记
        </div>
        <div class="out">

            <div class="search2">

              <el-button size="mini" type="primary" @click.native="toggleModalAdd">添加</el-button>

              <div style="clear: both;"></div>
            </div>

            <el-table class="table" size="mini" :data="tableData" :height="th" border style="width: 100%;">

                <el-table-column prop="visitorName" label="来访人姓名"></el-table-column>
                <el-table-column prop="visitorPhone" label="来访人手机号"></el-table-column>
                <el-table-column prop="remarks" label="描述"></el-table-column>
                <el-table-column prop="createTime" :formatter="formatterTime" label="来访时间"></el-table-column>
              <el-table-column fixed="right" label="操作" width="200">
                <template slot-scope="scope">
                  <el-button type="primary" size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                </template>
              </el-table-column>
            </el-table>

            <div class="page">
                <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                <div style="float: left;">
                    <el-pagination small
                            background
                            layout="prev, pager, next"
                            :total="totalItems"
                            :page-size="20"
                            @current-change="current_change">
                    </el-pagination>
                </div>
                <div style="clear: both;"></div>
            </div>

        </div>

        <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>

    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import Edit from "./Edit";
    import Add from "./Add";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:false,
                disabledAdd:true,
                showModalAdd:false,
                showModalEdit:false,
                searchDishes:'',
                tableData:null,
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                status:-1,
                statusValue:[{name:'全部状态',value:-1},{name:'正常',value:0},{name:'禁用',value:1}]

            }
        },
        components:{
            Add,Edit
        },
        created(){
            this.getList();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{

            handleEdit(index, row) {
                this.$refs.myEdit.init(row);
                this.showModalEdit = !this.showModalEdit;
            },
            formatterTime(row, column, cellValue) {
                return cellValue.replace('T',' ').slice(0,19)
            },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            toggleModalEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            statusTitle(row){
                if(row.status == 0){
                    return "正常";
                }
                if(row.status == 1){
                    return "禁用";
                }
                return "其它";
            },
            getList(){

                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"ReceptionRecord/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                }).catch(function (error) {
                    console.log(error);
                });
            },



        }


    }


</script>

<style scoped>

</style>
